import useRootData from './useRootData';

export default function useRegion() {
  const { region } = useRootData();

  return region;
}
